module.exports = __webpack_public_path__ + "img/only-user.0e08dc25.svg";